<ng-container *ngIf="isDispatcher">
  <a data-e2e="link" class="entity" [routerLink]="link" [queryParams]="params"
    *ngIf="isEnabledLink" [target]="target">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
  <span class="entity disabled" *ngIf="isDisabledLink">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </span>
  <span class="entity" *ngIf="!isLink">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </span>
</ng-container>

<span class="entity" *ngIf="!isDispatcher">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</span>


<ng-template #content>
  {{text}}
  <ng-content></ng-content>
</ng-template>
